import { render } from "./BadgeState.vue?vue&type=template&id=96c81fb8&scoped=true&ts=true"
import script from "./BadgeState.vue?vue&type=script&lang=ts"
export * from "./BadgeState.vue?vue&type=script&lang=ts"

import "./BadgeState.vue?vue&type=style&index=0&id=96c81fb8&lang=scss&scoped=true"
import "./BadgeState.vue?vue&type=style&index=1&id=96c81fb8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c81fb8"]])

export default __exports__